export default "__VITE_ASSET__e84c6d92__"